<template>
    <div id="produk-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    to: { path: '/landing-banners' },
                    exact: true,
                },
                {
                    text: 'Banner Android',
                    to: { path: '/android-banners' },
                    exact: true,
                },
                { text: $route.query.baru ? 'Tambah Banner' : 'Ubah Banner' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ $route.query.baru ? "Tambah" : "Ubah" }} Banner Android
        </h3>

        <v-card style="border">
            <v-card-title> Detail Banner </v-card-title>
            <v-divider />
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : data.image && data.image != ''
                                                  ? data.image
                                                  : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload *
                            </v-btn>
                            <input
                                id="oss_config_android_banner_image"
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Rasio thumbnail foto 16:9
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 200 KB
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        ID *
                                    </v-list-item-title>

                                    <v-text-field
                                        id="oss_config_android_banner_id"
                                        v-model="data.id"
                                        placeholder="ID"
                                        required
                                        outlined
                                        v-on:keypress="
                                            /\d/.test(
                                                String.fromCharCode(
                                                    $event.keyCode,
                                                ),
                                            )
                                                ? true
                                                : $event.preventDefault()
                                        "
                                        @change="
                                            data.id = data.id.replace(/\D/g, '')
                                        "
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        URL
                                    </v-list-item-title>

                                    <v-text-field
                                        id="oss_config_android_banner_url"
                                        v-model="data.link"
                                        placeholder="Link"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Type *
                                    </v-list-item-title>

                                    <v-text-field
                                        id="oss_config_android_banner_type"
                                        v-model="data.type"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Show In Home
                                    </v-list-item-title>
                                    <div class="d-inline">
                                        <v-checkbox
                                            id="oss_config_android_banner_status"
                                            label="Aktif"
                                            v-model="data.is_home"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Show In Live Class
                                    </v-list-item-title>
                                    <div class="d-inline">
                                        <v-checkbox
                                            id="oss_config_android_banner_status"
                                            label="Aktif"
                                            v-model="data.is_live_class"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-card-actions class="pa-4" v-if="data.type">
                            <v-spacer></v-spacer>
                            <v-btn
                                id="oss_config_android_banner_hapus"
                                depressed
                                class="px-6 py-2 white--text"
                                color="redLight"
                                v-show="!$route.query.baru"
                                @click="confirmDelete($event)"
                                >Hapus</v-btn
                            >
                            <v-btn
                                id="oss_config_android_banner_simpan"
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                @click="upload()"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            upload(1);
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import Spinner from "@/components/plugins/Spinner";
import uniqid from "uniqid";

export default {
    name: "android-banner-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            queryId: null,
            selectedPicture: null,
            data: {
                id: null,
                image: "",
                link: "",
                type: "",
                is_review: false,
                is_active: false,
                is_home: false,
                is_live_class: false,
            },
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            url: null,
            addNew: false,
            keyimg: 0,
            imageFile: null,
            tumbnail: null,
            onDelete: false,
            tryouts: [],
        };
    },

    mounted: function () {
        if (this.$route.query.baru) this.addNew = true;
        if (!_.isEmpty(this.$store.state.androidbanners.onEdit))
            this.data = this.$store.state.androidbanners.onEdit;
        if (!this.data) {
            this.$router.push("/android-banners");
        }
    },

    destroyed() {
        this.$store.commit("android_banners_clear");
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        confirmDelete: function (video) {
            this.dialogConfirm.title =
                "Apakah Anda yakin akan menghapus banner ini?";
            this.dialogConfirm.function = video;
            this.dialogConfirm.open = true;
        },

        async upload(e = 0) {
            this.isLoading = true;
            const fileImage = this.$refs.uploader.files[0];

            if (this.imageFile && !this.data.image) {
                if (!fileImage) {
                    this.$store.commit("showAlert", {
                        message: `File Banner harus diisi!`,
                        type: "error",
                    });
                    return;
                }
            }

            if (e) {
                this.onDelete = true;
                this.data.id = 0;
            }

            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.image && !file) {
                    this.thumbnail = this.data.image;
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key:
                            "banners/android_banner_" +
                            new Date().valueOf() +
                            "_" +
                            file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.thumbnail = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async save() {
            var context = this;
            if (this.validateForm()) {
                context.isLoading = true;
                try {
                    var oldArr = this.$store.state.androidbanners.data;
                    const infos = this.$store.state.androidbanners.editInfoId;
                    var raws = this.$store.state.androidbanners.raw;

                    if (this.addNew) {
                        var newArr = oldArr.filter(
                            (e) => e.id != parseInt(this.data.id),
                        );
                    } else {
                        var newArr = oldArr.filter(
                            (e) =>
                                e.id != infos && e.id != parseInt(this.data.id),
                        );
                    }

                    if (!this.data.id) {
                        newArr = newArr.filter((e) => e.id != 0);
                    } else {
                        if (
                            this.addNew &&
                            oldArr.find((s) => s.id == parseInt(this.data.id))
                        ) {
                            this.$store.commit("showAlert", {
                                message: `ID Banner sudah digunakan`,
                                type: "error",
                            });
                            context.isLoading = false;
                            return 0;
                        } else if (
                            this.data.id != infos &&
                            oldArr.find(
                                (s) => parseInt(s.id) == parseInt(infos),
                            ) &&
                            oldArr.find((s) => s.id == parseInt(this.data.id))
                        ) {
                            this.$store.commit("showAlert", {
                                message: `ID Banner sudah digunakan`,
                                type: "error",
                            });
                            context.isLoading = false;
                            return 0;
                        }

                        newArr = _.uniqBy(newArr, "id");
                        this.data.id = parseInt(this.data.id);
                        this.data.image = this.thumbnail;
                        if (this.data.is_home || this.data.is_live_class) {
                            this.data.is_active = true;
                        } else {
                            this.data.is_active = false;
                        }
                        newArr.push(this.data);
                    }

                    context.$store.commit("android_banners_edited", newArr);
                    raws.ads = _.orderBy(newArr, ["id"], ["asc"]);

                    const parsed = JSON.stringify(raws, null, "\t");
                    const blob = new Blob([parsed], {
                        type: "application/json",
                    });

                    await this.$alioss.put("config/home", blob);
                    context.isLoading = false;

                    if (this.addNew) {
                        this.$store.commit("showAlert", {
                            message: `Berhasil Tambah Data`,
                            type: "success",
                        });
                    } else if (this.onDelete) {
                        this.$store.commit("showAlert", {
                            message: `Berhasil Hapus Data`,
                            type: "success",
                        });
                    } else {
                        this.$store.commit("showAlert", {
                            message: `Berhasil Update Data`,
                            type: "success",
                        });
                    }
                    setTimeout(() => {
                        this.$router.push("/android-banners");
                    }, 500);
                } catch (error) {
                    context.isLoading = false;
                }
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            if (!this.imageFile && !this.data.image) {
                this.$store.commit("showAlert", {
                    message: `Wajib upload gambar!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.onDelete) {
                if (
                    !this.data.id ||
                    this.data.id == "" ||
                    this.data.id == NaN
                ) {
                    this.$store.commit("showAlert", {
                        message: `ID wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }
            }

            if (!this.data.type) {
                this.$store.commit("showAlert", {
                    message: `Tipe wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// Form.vue?6e2a94f6